import { MultiselectCommand } from '../../core/model/command';

export const ControlDataExportCommand = {
  printToPdf: 'printKU55ToPdf',
  regenerateControlData: 'regenerateControlData',
  generateNewControlDataFile: 'generateNewControlDataFile',
};

export class ControlDataExportMultiselectCommand extends MultiselectCommand {
  constructor(id: string, items: any[], itemsSource: any[], contextId?: string) {
    super(id, items, itemsSource, contextId);
  }
}
